
import { FETCH_ALL_DEKIT, FETCH_DEKIT_STATUS_COUNT, FETCH_MODULE_WISE_TOUR_STEPS } from "../types"
const INIT_STATE = {

    moduleWiseTourSteps: null
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_MODULE_WISE_TOUR_STEPS: return { ...state, moduleWiseTourSteps: action.payload }
        // case FETCH_DEKIT_STATUS_COUNT: return { ...state, statusCount: action.payload }
        // case FETCH_DEKIT_DETAIL: return { ...state, deKitDetail: action?.payload?.data, deKitDetailItemCount: action?.payload?.count || 0 }

        default: return state
    }
}
